<template>
  <div class="schedule">
    <div class="schedule-head">
      <img :src="dataSource.image" alt="" class="schedule-head-image">
      <div class="schedule-head-bottom" @click="gotoSignUp">
        <span class="schedule-icon-detail"></span>
        课程介绍
        <span class="schedule-icon-arrow"></span>
      </div>
    </div>

    <div class="schedule-enter" @click="gotoPromoteResult">
      <div class="schedule-enter-head">
        <div class="schedule-enter-title">新生入学</div>
        <UIButton
          type="green"
          height="50"
          width="140"
          fontSize="24"
          class="schedule-enter-button"
        >进入班级</UIButton>
      </div>
      <ul class="schedule-enter-list">
        <li class="schedule-enter-item">
          <i class="schedule-icon-ok" />
          7天改变，从现在开始。
        </li>
        <li class="schedule-enter-item">
          <i class="schedule-icon-ok" />
          新人学习两步走，点我赶快加入吧~
        </li>
      </ul>
    </div>

    <ul class="schedule-list">
      <li
        class="schedule-item"
        v-for="item in chapterList"
        :key="item.id"
        :class="{ gray: !item.isPublished }"
      >
        <div class="schedule-icon-lock" v-if="!item.isPublished" />
        <div class="schedule-item-date">
          {{item.publishDateNoYearStr}}
          <span class="schedule-item-status green" v-if="item.isSignIn">已打卡</span>
          <span class="schedule-item-status gray" v-else-if="!item.isPublished">未打卡</span>
          <span class="schedule-item-status orange" v-else>未打卡</span>
        </div>
        <div class="schedule-item-name">{{item.name}}</div>
        <div class="schedule-item-button">
          <UIButton
            height="50"
            width="140"
            fontSize="24"
            :disabled="!item.isPublished"
            @click="handleSelect(item)"
            @disabled-click="handleSelectDisabled(item)"
          >进入学习</UIButton>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  // 复制老课程表, 修改为新课程表
  // 新课程表只为1元训练营课程服务
  // 其他课程, 和报名页的课程表部分, 依然使用老课程表
  // 新课程表只有小节, 没有章

  import os from '@edu-fe/os'
  import UIButton from './UI/Button'
  import { isxxx } from '@mixins'

  export default {
    name: 'ScheduleList2',

    mixins: [isxxx],

    props: {
      dataSource: {
        type: Object,
        required: true
      }
    },

    computed: {
      chapterList () {
        return this.dataSource.chapterList || []
      }
    },

    methods: {
      handleSelect (chapter) {
        if (chapter.liveState === -1) { // 非直播课
          if (chapter.isPublished) {
            // 区分音/视频详情
            switch (chapter.mediaType) {
              case 1: // 视频
                // if (this.isWx) {
                //   window.location.href = `https://edu-m.wps.cn/video-detail?courseId=${this.dataSource.courseId}&chapterId=${chapter.id}&from=${this.$route.query.from}`
                //   return
                // }
                this.$router.push(`/video-detail?courseId=${this.dataSource.courseId}&chapterId=${chapter.id}`)
                return
              case 2: // 音频
                // if (this.isWx) {
                //   window.location.href = `https://edu-m.wps.cn/audio-detail?courseId=${this.dataSource.courseId}&chapterId=${chapter.id}&from=${this.$route.query.from}`
                //   return
                // }
                this.$router.push(`/audio-detail?courseId=${this.dataSource.courseId}&chapterId=${chapter.id}`)
                return
            }
          }
        } else { // 直播课
          this.$router.push(`/live?chapterId=${chapter.id}`)
        }
      },

      handleSelectDisabled (item) {
        this.$toast.show({
          message: `本节课将于${item.publishDateNoYearStr}解锁学习`
        })
      },

      handleFoldSection (section) {
        this.$emit('fold', section)
      },

      gotoSignUp () {
        this.$router.push({
          name: 'sign-up',
          query: {
            courseId: this.dataSource.courseId
          }
        })
      },

      gotoPromoteResult () {
        this.$router.push({
          name: 'sign-up-result-for-promote',
          query: {
            courseId: this.dataSource.courseId
          }
        })
      }
    },

    components: {
      UIButton
    }
  }
</script>

<style lang="scss" scoped>
  @charset 'utf-8';
  @import '../style/main';

  $global-width: 750;

  .schedule {
    overflow: hidden;
    background-color: #fff;

    &-icon {
      &-detail {
        display: inline-block;
        vertical-align: middle;
        width: use(30);
        height: use(30);
        background-image: url('../assets/icons/schedule-detail.svg');
        background-size: 100% 100%;
        position: relative;
        top: -1px;
      }

      &-arrow {
        display: inline-block;
        vertical-align: middle;
        width: use(8);
        height: use(16);
        background-image: url('../assets/icons/schedule-arrow.svg');
        background-size: 100% 100%;
      }

      &-ok {
        position: absolute;
        top: 0;
        left: 0;
        width: use(36);
        height: use(36);
        background-image: url('../assets/icons/schedule-ok.svg');
        background-size: 100% 100%;
      }

      &-lock {
        position: absolute;
        top: 0;
        right: 0;
        width: use(132);
        height: use(132);
        background-image: url('../assets/icons/schedule-lock.svg');
        background-size: 100% 100%;
      }
    }

    &-head {
      width: use(690);
      margin: use(30) auto use(20);
      border-radius: use(10);
      overflow: hidden;
      background-color: #fff;
      box-shadow: rgba(#BDC9D1, .56) 0 use(2) use(30);

      &-image {
        display: block;
        width: 100%;
      }

      &-bottom {
        height: use(80);
        line-height: use(80);
        text-align: right;
        padding-right: use(30);
      }
    }

    &-enter {
      padding: 0 use(32);
      margin: use(30) use(30) use(40);
      background-color: #F3F4F5;
      border-radius: use(10);

      &-head {
        display: table;
        width: 100%;
        border-bottom: 1px solid #D8D8D8;
      }

      &-title {
        float: left;
        margin-top: use(35);
        font-size: use(32);
        line-height: use(45);
        color: #333333;
        font-weight: bold;
      }

      &-button {
        float: right;
        margin-top: use(32);
        margin-bottom: use(24);
      }

      &-list {
        padding-top: use(20);
        padding-bottom: use(30);
      }

      &-item {
        margin-top: use(12);
        padding-left: use(52);
        position: relative;
        font-size: use(28);
        line-height: use(40);
        color: #333333;
      }
    }

    &-list {
      padding-left: use(30);
    }

    &-item {
      $gray: & + '.gray';

      position: relative;
      padding-top: use(42);
      padding-right: use(30);
      padding-bottom: use(30);
      border-bottom: 1px solid #EBEBEB;

      &:last-child {
        border-bottom: none;
      }

      &-date {
        font-size: use(32);
        line-height: 1;
        color: #333333;
        font-weight: bold;

        #{$gray} & {
          color: #999999;
        }
      }

      &-status {
        font-size: use(22);
        line-height: 1;
        font-weight: normal;
        padding: 0 use(6);
        border-radius: use(6);
        border-bottom-left-radius: 0;
        position: relative;
        top: -1px;

        &.orange {
          color: #F48F00;
          background-color: #FFF7E8;
          border: 1px solid #FFB500;
        }

        &.green {
          color: #42CA59;
          background-color: #F2FFF4;
          border: 1px solid #51CE5C;
        }

        &.gray {
          color: #999999;
          border: 1px solid #B7B7B7;
        }
      }

      &-name {
        padding: use(30) 0;
        font-size: use(28);
        line-height: use(44);
        color: #333333;

        #{$gray} & {
          color: #999999;
        }
      }

      &-button {
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  $global-width: 720;
</style>
